import React, { useCallback, useEffect } from 'react'
import { useAtom } from 'jotai'
import { StyledTodoListDropdown } from './styled'
import { TodoListDropdownProps } from './types'
import { API } from 'javascripts/api'
import { todoListAtom, TODO_LIST_REFRESH_EVENT } from 'spa/member/atoms/TodoList/todoListAtom'

// 登録後にやることリストの状態をAPIから取得し、表示可否を判定する
export const TodoListDropdown: React.FC<TodoListDropdownProps> = props => {
  const [{ todoList }, setTodoListState] = useAtom(todoListAtom)

  const fetchTodoList = useCallback(() => {
    void API.getUserTodoList().
      then(response => setTodoListState({ status: 'loaded', todoList: response.data })).
      catch((error: unknown) => {
        console.error(error)
        setTodoListState({ status: 'error', todoList: null })
      })
  }, [setTodoListState])

  useEffect(() => {
    // NOTE: Headerがページ遷移のたびに再マウントされてもAPIを何度も取得しないよう、
    // atomの取得状態を見て未取得（または失敗済み）のときのみ取得する
    let shouldFetch = false
    setTodoListState(prev => {
      if (prev.status !== 'idle' && prev.status !== 'error') return prev

      shouldFetch = true
      return { ...prev, status: 'loading' }
    })
    if (shouldFetch) fetchTodoList()

    // 案件への応募完了などやることリストの状態が変わりうる操作が行われた際に、
    // 同一ページ内の別バンドルから通知を受け取って再取得する
    window.addEventListener(TODO_LIST_REFRESH_EVENT, fetchTodoList)
    return () => window.removeEventListener(TODO_LIST_REFRESH_EVENT, fetchTodoList)
  }, [fetchTodoList, setTodoListState])

  if (!todoList?.visible) return null

  return <StyledTodoListDropdown {...props} todoList={todoList} />
}
